import { jsx } from "react/jsx-runtime";
import cx from "classnames";
const PaymentLogo = (props) => {
  const { src, alt, size, className, prefix = "", ...otherProps } = props;
  const classes = cx(
    `${prefix}payment-logo`,
    size && `${prefix}payment-logo--${size}`,
    className
  );
  if (!src) {
    return null;
  }
  return /* @__PURE__ */ jsx("span", { ...otherProps, className: classes, children: /* @__PURE__ */ jsx("img", { className: `${prefix}payment-logo__img`, src, alt }) });
};
var PaymentLogo_default = PaymentLogo;
export {
  PaymentLogo_default as default
};
